<template>
    <span
        :class="['icon-svg', `icon-svg--${name}`, shadow ? 'icon-shadow' : null]"
        aria-hidden="true"
        :style="`--svg-size: ${size}px`"
    >
        <svg class="icon-svg__svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <use :xlink:href="href" width="100%" height="100%" focusable="false"></use>
        </svg>
    </span>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = withDefaults(
    defineProps<{
        name: string;
        size?: number | string;
        shadow?: boolean;
    }>(),
    {
        size: 20,
        shadow: false,
    },
);

const href = computed(() => {
    return `${environment.sportBetsRootUrl}svg/sprite.svg?${new Date().toLocaleDateString("cs-CZ").split(". ").join("_")}#${props.name}`;
});
</script>
